import styled, { css } from 'styled-components';

import { mediaDesktop } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

interface ArticleNextSectionWrapperProps {
  hoverTextColor?: string;
}

export const ArticleNextSectionWrapper = styled.a<ArticleNextSectionWrapperProps>`
  max-width: 50%;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 56px 0 80px 0;

  background-color: ${colors.concrete};

  &:hover {
    background-color: ${colors.mercury};
  }

  ${({ hoverTextColor }) =>
    hoverTextColor?.length &&
    css`
      &:hover,
      &:hover * {
        color: ${colors[hoverTextColor] ?? hoverTextColor};
      }
    `}

  &:first-child {
    border-bottom: 1px solid ${colors.mercury};

    ${mediaDesktop(css`
      border: none;
    `)}
  }

  ${mediaDesktop(css`
    padding: 72px 0 130px 0;
  `)}
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  padding: 0 16px;

  p {
    &:last-child {
      margin-top: 8px;
    }
  }

  ${mediaDesktop(css`
    padding: 0 138px 0 124px;

    p {
      &:last-child {
        margin-top: 16px;
      }
    }
  `)}
`;
